export const SET_DOWNLOAD = 'SET_DOWNLOAD'
export const RESET_DOWNLOAD = 'RESET_DOWNLOAD'

export default {
  SET_DOWNLOAD,
  RESET_DOWNLOAD
}
